import { HeartBank } from "../../managers/HeartBank.ts";
import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase.ts";
import { analytics, performance } from "../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent, setUserProperties } from "firebase/analytics";

import template from "./sw-header.mjs";
import { Bookmarks } from "../../managers/Bookmarks.ts";
import Strings from "../../models/Strings.json";
import Bedok from "../../models/Bedok.json";
import { LANGUAGE, MAP } from "../global.ts";
import { SwFeedback } from "../sw-footer/sw-feedback/sw-feedback.ts";
import { SwPopup } from "../sw-footer/sw-popup/sw-popup.ts";
import { SwToc } from "./sw-toc/sw-toc.ts";
import { SwMap } from "../sw-main/sw-map/sw-map.ts";
import { Transcriptions } from "../../managers/Transcriptions.ts";

const LANGUAGE2 = "khmer";
const strings: any = Strings;
const bedok: any = Bedok;

export class SwHeader extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private transcriptions: Transcriptions = new Transcriptions();
    private componentTrace: PerformanceTrace;
    private bookmarks = new Bookmarks();

    private feedback = document.querySelector("sw-feedback") as SwFeedback;
    private popup2 = document.querySelector("sw-popup") as SwPopup;
    private toc = document.querySelector("sw-toc") as SwToc;
    private popup: Window | null = null;
    private hasShownFeedback = false;

    private titleHome: HTMLDivElement;
    private home: HTMLElement;
    private khmer: HTMLElement;
    private english: HTMLElement;

    private titlePage: HTMLDivElement;
    private basket: HTMLButtonElement;
    private number: HTMLSpanElement;
    private page: HTMLElement;
    private bookmark: HTMLButtonElement;
    private bookmarked: HTMLButtonElement;

    private titleMap: HTMLDivElement;
    private mapName: HTMLButtonElement;
    private map: HTMLElement;
    private mapMe: HTMLButtonElement;

    private prize: HTMLImageElement;
    private calendar: HTMLDivElement;
    private hbBtn: HTMLButtonElement;
    private fbBtn: HTMLButtonElement;

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-header");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.titleHome = this.querySelector("#title-home")!;
        this.home = this.querySelector("#sw-header-home")!;
        this.khmer = this.querySelector("#khmer")!;
        this.english = this.querySelector("#english")!;

        this.titlePage = this.querySelector("#title-page")!;
        this.basket = this.titlePage.firstElementChild as HTMLButtonElement;
        this.number = this.titlePage.lastElementChild as HTMLSpanElement;
        this.page = this.querySelector("#sw-header-page")!;
        this.bookmark = this.querySelector("#book-mark")!;
        this.bookmarked = this.querySelector("#book-marked")!;

        this.titleMap = this.querySelector("#title-map")!;
        this.mapName = this.titleMap.firstElementChild as HTMLButtonElement;
        this.map = this.querySelector("#sw-header-map")!;
        this.mapMe = this.querySelector("#sw-header-map-me")!;

        this.prize = this.querySelector("#sw-header-map-prize")!;
        this.calendar = this.querySelector("#sw-header-map-calendar")!;
        this.hbBtn = this.querySelector("#sw-header-map-heartbank")!;
        this.fbBtn = this.querySelector("#sw-header-map-feedback")!;
    }

    connectedCallback() {
        this.khmer.addEventListener("click", (event: Event) =>
            this.changeLanguage("khmer")
        );
        this.english.addEventListener("click", (event: Event) =>
            this.changeLanguage("english")
        );

        this.bookmark.addEventListener("click", async () => {
            this.bookmark.disabled = true;
            await this.updateBookmark(true);
            if (!this.hasShownFeedback && !this.heartbank.isLoggedIn) {
                this.feedback.show();
                this.hasShownFeedback = true;
                alert(strings.feedback14[LANGUAGE]);
            }
            this.bookmark.disabled = false;
        });
        this.bookmarked.addEventListener("click", async () => {
            this.bookmarked.disabled = true;
            await this.updateBookmark(false);
            this.bookmarked.disabled = false;
        });

        this.number.addEventListener("click", this.downloadPDF.bind(this));
        this.prize.addEventListener("click", () =>
            this.calendar.classList.toggle("hidden")
        );
        this.calendar.addEventListener("click", () =>
            this.calendar.classList.toggle("hidden")
        );

        this.hbBtn.addEventListener(
            "click",
            this.feedback.show.bind(this.feedback)
        );
        this.fbBtn.addEventListener(
            "click",
            this.feedback.show.bind(this.feedback)
        );

        this.mapName.addEventListener("click", () => {
            //document.location.hash = "#bookmark";
            //window.history.back();
        });
        this.mapMe.addEventListener("click", () => {
            const map = document.querySelector("sw-map") as SwMap;
            map.panToUser();
        });

        this.heartbank.addAuthStateListener3((hero, user) => {
            const paths = window.location.hash.split("/");
            if (paths[2] !== undefined && paths[4] !== undefined) {
                const book = parseInt(paths[2]);
                const page = parseInt(paths[4]);
                this.renderBookmark(book, page);

                if (user)
                    this.bookmarks.setupRealtimeListener(
                        user.uid,
                        book,
                        (page: number) => this.renderBookmark(book, page)
                    );
            }

            // name might be too long
            // this.mapMe.textContent =
            //     hero?.displayName || strings.map16[LANGUAGE];

            // if (user) {
            //     this.hbBtn.classList.replace("inline-flex", "hidden");
            //     this.fbBtn.classList.replace("hidden", "inline-flex");
            // } else {
            //     this.fbBtn.classList.replace("inline-flex", "hidden");
            //     this.hbBtn.classList.replace("hidden", "inline-flex");
            // }
        });

        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    show() {
        this.classList.remove("hidden");
    }

    hide() {
        this.classList.add("hidden");
    }

    showHome() {
        this.titleHome.classList.remove("hidden");
        this.titlePage.classList.add("hidden");
        this.titleMap.classList.add("hidden");

        this.home.classList.remove("hidden");
        this.page.classList.remove("inline-flex");
        this.page.classList.add("hidden");
        this.map.classList.replace("inline-flex", "hidden");
    }

    showPage() {
        this.titlePage.classList.remove("hidden");
        this.titleHome.classList.add("hidden");
        this.titleMap.classList.add("hidden");

        this.page.classList.add("inline-flex");
        this.page.classList.remove("hidden");
        this.home.classList.add("hidden");
        this.map.classList.replace("inline-flex", "hidden");

        this.render();
    }

    showMap(page: "leaderboard" | "now" | "history" = MAP) {
        this.titleMap.classList.remove("hidden");
        this.titlePage.classList.add("hidden");
        this.titleHome.classList.add("hidden");

        this.map.classList.replace("hidden", "inline-flex");
        this.page.classList.remove("inline-flex");
        this.page.classList.add("hidden");
        this.home.classList.add("hidden");

        switch (page) {
            case "leaderboard":
                this.mapName.textContent = strings.leaderboard[LANGUAGE];
                break;
            case "now":
                this.mapName.textContent = strings.now[LANGUAGE];
                break;
            case "history":
                this.mapName.textContent = strings.history[LANGUAGE];
                break;
        }
    }

    private async render() {
        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);

        const basket = this.getBasket(book);
        this.basket.classList.remove(...strings.baskets.colors);
        this.basket.classList.add(strings.baskets.colors[basket]);
        this.basket.textContent = strings.baskets2[LANGUAGE][basket];
        this.basket.addEventListener(
            "click",
            this.toc.show.bind(this.toc, "pali", 1, 1)
        );

        //await this.heartbank.waitForAuth();
        this.heartbank.addAuthStateListener3(() => {
            if (this.heartbank.isAdmin()) {
                this.number.classList.remove("cursor-pointer");
                this.number.classList.remove("cursor-progress");
                this.number.classList.add("cursor-crosshair");
            } else {
                this.number.classList.remove("cursor-progress");
                this.number.classList.remove("cursor-crosshair");
                this.number.classList.add("cursor-pointer");
            }
        });

        //this.number.target = "_blank";
        //this.number.href = Bedok["khmer"].pdfs[book - 1];
        this.number.textContent = book.toKhmer(LANGUAGE);
        this.renderBookmark(book, page);
    }

    // TODO: deprecate use Books.ts
    private getBasket(book: number): number {
        for (let index = 0; index < bedok[LANGUAGE2].baskets.length; index++) {
            const basket = bedok[LANGUAGE2].baskets[index];
            if (book <= basket + 1) return index;
        }
        return -1; // Return a default value if no basket is found
    }

    async updateBookmark(task: boolean) {
        if (this.heartbank.hero && !navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        const paths = window.location.hash.split("/");
        const book = parseInt(paths[2]);
        const page = parseInt(paths[4]);

        if (task) {
            await this.bookmarks.update(book, page);
        } else {
            await this.bookmarks.remove(book, page);
        }

        this.renderBookmark(book, page);

        // this.dispatchEvent(
        //     new CustomEvent<{ info: string }>("sw-banner", {
        //         bubbles: true,
        //         detail: {
        //             info: task
        //                 ? strings.saved[LANGUAGE]
        //                 : strings.removed[LANGUAGE]
        //         }
        //     })
        // );

        logEvent(analytics, "bookmark", { task, book, page });
    }

    async renderBookmark(book: number, page: number) {
        const bookmark = await this.bookmarks.get(book);

        if (bookmark === page) {
            this.bookmark.classList.add("hidden");
            this.bookmarked.classList.remove("hidden");
        } else {
            this.bookmark.classList.remove("hidden");
            this.bookmarked.classList.add("hidden");
        }
    }

    private changeLanguage(language: string) {
        localStorage.setItem("language", language);
        logEvent(analytics, "language", { language });
        window.location.reload();
    }

    private async downloadPDF(event: Event) {
        if (!navigator.onLine) {
            alert(strings.offline[LANGUAGE]);
            return;
        }

        //event.preventDefault();
        const a = document.createElement("a");

        if (this.heartbank.isAdmin()) {
            this.number.classList.replace(
                "cursor-crosshair",
                "cursor-progress"
            );

            const paths = window.location.hash.split("/");
            const book = parseInt(paths[2]);

            const getBookPages = httpsCallable<{ book: number }>(
                functions,
                "getBookPages",
                { limitedUseAppCheckTokens: true }
            );
            const result = await getBookPages({ book });

            const { khmer, pali, english } = result.data as any;
            a.href = `data:application/pdf;base64,${khmer}`;
            a.download = "Book " + book;
            // a.target = "_blank";
            // a.rel = "noopener"; // optional for security

            this.number.classList.replace(
                "cursor-progress",
                "cursor-crosshair"
            );
        } else this.toc.show("khmer", 1, 1);

        a.click();
    }
}
